import { Chip } from "@compass/core";

export const TextingStatusChip = (props: { status: string }) => {
  const isSuccess = ["completed", "sent"].includes(props.status.trim().toLowerCase());

  return (
    <Chip
      label={props.status}
      color={isSuccess ? "success" : "default"}
      size="small"
      variant="outlined"
    />
  );
};
